import { atom } from 'jotai';

import { COMPANY_CODES } from '../utils';
import { companyIdAtom } from './companyIdAtom';

export const companyNameAtom = atom((get) => {
  const companyId = get(companyIdAtom);
  return companyId !== undefined ? COMPANY_CODES[companyId] : undefined;
});
